import loadVisualFilters from "@NA/Handlers/ADIVisualFiltersHandler";
import createVisualNavigation from "@NA/Handlers/ADIVisualNavigationCreateHandler";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getSelectedCategoryPath } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCatalogPageStateByPath } from "@insite/client-framework/Store/Data/CatalogPages/CatalogPagesSelectors";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import addProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import clearAllProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/ClearAllProductFilters";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import Img, { ImgProps } from "@insite/mobius/Img/Img";
import { TypographyProps } from "@insite/mobius/Typography";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { Clickable, GridContainer, GridItem, Typography } from "@insite/mobius/index";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getColor from "@insite/mobius/utilities/getColor";
import { useEmblaCarousel } from "embla-carousel/react";
import React, { useCallback, useMemo, useState, useEffect, useContext, useRef } from "react";
import { FC } from "react";
import { ResolveThunks, connect, useDispatch } from "react-redux";
import { css } from "styled-components";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import ADIColors from "@NA/Utils/ADIColors";
import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import Radio from "@insite/mobius/Radio";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import RadioGroup, { RadioGroupProps, RadioGroupStyle } from "@insite/mobius/RadioGroup";
import DatePicker, { DatePickerPresentationProps, DatePickerState } from "@insite/mobius/DatePicker";
import ADIProductListVisualFilterModal from "./ADIProductListVisualFilterModal";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import { VisualFilter, categoryId } from "@NA/Services/GetVisualCarousal";
import translate from "@insite/client-framework/Translate";
import EmblaCarouselWrappeForVisNav from '@NA/Components/EmblaCarouselWrappeForVisNav';
import { IconPresentationProps } from '@insite/mobius/Icon';

const mapStateToProps = (state: CustomApplicationState) => {
    const location = getLocation(state);
    const selectedCategoryPath = getSelectedCategoryPath(state);
    const path =
        selectedCategoryPath || (location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname);
    const catalogPage = getCatalogPageStateByPath(state, path).value;
    const catalogPath = catalogPage?.uri.split('?path=')[1];

    return {
        category: getCategoryState(state, catalogPage?.categoryIdWithBrandId ?? catalogPage?.categoryId).value,
        isLoading: state.ADIGlobalData.visualFilterStore.isLoading,
        visualFilterState: state.ADIGlobalData.visualFilterStore.visualFilterState,
        catalogPage,
        session: getSession(state),
        location,
        catalogPath,
    };
};

const enum imageNameFields {
    imageName = "imageName",
}

interface OwnProps extends WidgetProps {
    fields: {
        [imageNameFields.imageName]: string;
    };
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;


interface VisualFilterState {
    visualFilters: VisualFilter[];
}

const mapDispatchToProps = {
    loadVisualFilters,
    createVisualNavigation,
    addProductFilters,
    clearAllProductFilters,
};

export interface visualFilterInterface {
    boxContainer?: InjectableCss;
    boxContainerForNonEditable?: InjectableCss;
    boxContainerForMobile?:InjectableCss;
    images?: ImgProps;
    title?: TypographyProps;
    mainContainer?: GridContainerProps;
    mainContainerViewOnly?:InjectableCss;
    boxItem?: GridItemProps;
    carouselContainer?: InjectableCss;
    carouselSlidesContainer?: InjectableCss;
    carouselSlide?: InjectableCss;
    carouselSlideInner?: InjectableCss;
    dotsContainer?: InjectableCss;
    dots?: InjectableCss;
    dotsSelected?: InjectableCss;
    modalInputGrid?: GridItemProps;
    radioGridItem?: GridItemProps;
    radioListGroup?: RadioGroupProps;
    VNCloseIcon?: InjectableCss;
    VNEditIcon?: InjectableCss;
    editWrapper?: InjectableCss;
    dateWrapper?: InjectableCss;
    fromDate?: DatePickerPresentationProps;
    toDate?: DatePickerPresentationProps;
    saveNavigationBtn?: ButtonPresentationProps;
    editNavigationLink?: LinkPresentationProps;
    resetCalenderBtn?: LinkPresentationProps;
    errorModalWrap?: InjectableCss;
    errorModalClose?: InjectableCss;
    dateMainWrap?: InjectableCss;
    parentWrap?: InjectableCss;
    neverExpired?: InjectableCss;
    errorModal?: ModalPresentationProps;
    arrowWrapper? : InjectableCss;
    prevArrowButton?: ButtonPresentationProps;
    iconProps?: IconPresentationProps;
    nextArrowButton?: ButtonPresentationProps;
    nonEditableTopContainer?:InjectableCss;
    emblaWapperTopContainer?:InjectableCss;
}

export const visualFilterStyles: visualFilterInterface = {
    
    emblaWapperTopContainer: {
        css: css`
           width: 100%;
           display: flex;
           justify-content: center;
        `,
    },
    prevArrowButton: {
        variant: "secondary",
        color: "text.main",
        css: css`
        margin-left:-10px;
         transform: rotate(180deg);
            background: url(https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Themes/newicons/arrow-carousel-next-rd.svg)
                no-repeat;
                border:0;
                 background-size: 32px 32px !important
            &:disabled {
                background: url(https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/ArrowCarouselright-2.svg)
                    no-repeat;
            }
        `,
    },
    nextArrowButton: {
        variant: "secondary",
        color: "text.main",
        css: css`
            background: url(https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Themes/newicons/arrow-carousel-next-rd.svg)
                no-repeat;
            border: 0;
            background-size: 32px 32px !important
            &:disabled {
                background: url(https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/ArrowCarouselright-2.svg)
                    no-repeat;
            }
        `,
    },
    iconProps: {
        size: 40,
        color: "primary",
        css: css`
            > svg {
                color: ${getColor("primary")};
            }
            top: -1.875em;
        `,
    },
    arrowWrapper: {
        css: css`
            width:32px;
            align-content:center;
        `,
    },
    parentWrap: {
        css: css`
            margin-bottom: 40px;
        `
    },
    errorModal: {
        cssOverrides: {
            modalBody: css`                   
                border-radius: 7px!important;
                box-shadow:0 1px 9px 0 rgba(0,0,0,.14)!important;
                border: none!important;
                background-color: #fff;!important;
                top: 10%;
                transform: translate(-0px, -60%);
                max-height: 100% !important;                                
            `,
            modalContent: css`
                padding : 0px 48px 43px 48px!important;
            `,
            modalTitle: css`
                padding :32px 48px 0px 48px!important;
                font-size: 16px;
                font-weight:400;
                line-height:24px;
                border:none !important;
            > h4 {
                font-size: 16px;
                font-weight:400;
                line-height:24px;              
                color: #060001;                
            }
            > button {
                position: absolute;
                right: 5px;
                top: 5px;
                > span {
                    color: #006AE3;
                    width: 35px;
                    height: 35px;
                    > svg {
                        color: #006AE3;
                        width: 35px;
                        height: 35px;
                        stroke-width: 1px;
                    }             
                }                 
            }           
            `,
        }
    },
    errorModalClose: {
        css: css`
            border: 1px solid #006AE3;
            box-shadow: inset 0 -4px 0 0 #004da6;
            background: #006AE3;
            &:hover{
                border: 1px solid #006AE3;
                box-shadow: inset 0 -4px 0 0 #004da6;
                background: #006AE3;
            }

    `
    },
    errorModalWrap: {
        css: css`
            margin-bottom: 30px;
            span {
                    font-size: 20px;
                    font-weight: 700;
                    line-height: 28px;
                    margin-bottom: 0;
                    color: ${ADIColors.danger}; 
                    width: 75%;
                    display: block;
            }
        `
    },
    saveNavigationBtn: {
        css: css`
            position: absolute;
            right: 2rem;
            top: 8.2rem;
        `
    },
    editNavigationLink: {
        css: css`
            position: absolute;
            right: 2rem;
            top: 8.2rem;
            span {
                font-weight: bold;
                font-size: 14px;
                &:hover {
                    text-decoration: underline;
                }
            }
        `
    },
    resetCalenderBtn: {
        css: css`
            span {
                font-weight: bold;
                font-size: 14px;
            }
        `
    },
    neverExpired: {
        css: css`
        position: absolute;
        right: 137px;
        margin-top: 4px;
        background: ${ADIColors.white};
        color: ${ADIColors.blue5};
        font-size: 14px;
       font-weight: bold;
        `
    },
    dateMainWrap: {
        css: css`
            display: table;
            justify-content: center;
            margin: auto 0 0 auto;
            margin-bottom: -2px;
            position: relative;
            background-color: ${ADIColors.white};
        `,
    },
    dateWrapper: {
        css: css`
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-direction: row;
        border: 2px solid ${ADIColors.blue5};
        border-bottom: 0;
        padding: 10px 25px 5px 25px;
        background: #fff;
        line-height: normal;
            & > div {
                & > div {
                    margin-right: 2rem;
                    display: flex;
                    align-items: center;
                label {
                    width: auto !important;
                }
                & > div {
                    width: 140px !important;
                    padding: 0 !important;
                }
            }
            .react-datetime-picker {
                padding: 0 9px !important;
            }
        `
    },
    editWrapper: {
        css: css`
        margin-bottom: 40px;
        width: 100%;
        padding: 0;
        max-width: 1474px;
        margin: auto;
        border: 2px solid ${ADIColors.blue5};
        padding: 25px 15px 0;
        .vn-footer-text {
          padding: 0px;
          margin: 0px;
          font-size: 12px;
          color: ${ADIColors.lightBlack3};
          padding-bottom: 12px;
          text-align: right;
          padding-right: 1rem;
          font-weight: 400; 
        }
        `,
    },
    mainContainer: {
        gap: 30,
        css: css`
            margin-bottom: 60px;
            display:flex;
            gap: 5px;
            .visual-navigation-item {
                border-radius: 5px;
                background: ${ADIColors.white};
                position: relative;
                border: 2px solid #006AE3;
                margin: 0 15px 0 15px;
                padding: 10px 8px 12px 8px;
                display: flex;
                flex-grow: 1;
                height: 100%;
              }
              .visual-navigation-item.disabled {
                pointer-events: none; /* Disable clicking */
                opacity: 0.5; /* Adjust opacity to show it as disabled */
              }
        `,
    },
    mainContainerViewOnly:{
        css: css`
            display:flex;
            justify-content: center;
        `,
    },
    boxContainerForMobile:{
        css: css`
        display: flex;
        flex-direction: column;
        justify-content: center;
        cursor: pointer;
        button {
            display: flex;
            flex-direction: column;
            justify-content: center;
        }
    `,
    },
    boxContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: center;
            cursor: pointer;
            width:200px;
            button {
                display: flex;
                flex-direction: column;
                justify-content: center;
            }
        `,
    },boxContainerForNonEditable: {
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: center;
            cursor: pointer;
            width:222px;
            button {
                display: flex;
                flex-direction: column;
                justify-content: center;
            }
        `,
    },
    images: {

        css: css`
            padding: 0px;
            width: 100%;
            height: 100%;
            max-height: 116px;
            object-fit: contain;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-height: 75px;
                            min-height: 75px; 
                        `,
                        css`
                            max-height: 75px;
                            min-height: 75px; 
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    title: {
        css: css`
            padding: 10px 20px 0;
            text-align: center;
            font-size: ${getProp("theme.typography.h6.size")};
            color: #002856;
            font-weight: bold;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding: 10px 0px 0;
                            word-break: keep-all; 
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    boxItem: {
        css: css`
            justify-content: center;
        `,
    },
    carouselContainer: {
        css: css`
            overflow: hidden;
        `,
    },
    carouselSlidesContainer: {
        css: css`
            display: flex;
            gap: 5px;
        `,
    },
    carouselSlide: {
        css: css`
            flex: 0 0 calc(100% / 3);
            padding: 0;
            position: relative;
            img {
                width: 83px;
                margin: 0 auto;
            }
        `,
    },
    carouselSlideInner: {
        css: css`
            width: 100%;
            text-align: center;
            position: relative;
            padding: 0px 3px 0;
            > button {
                position: relative;
                width: 100%;
            }
        `,
    },
    dotsContainer: {
        css: css`
            display: flex;
            justify-content: center;
            margin: 20px 0;
        `,
    },
    dots: {
        css: css`
            width: 50px;
            height: 4px;
            border-radius: 2px 2px 2px 2px;
             margin-left:-2px;
             margin-right:-2px;
            background: ${ADIColors.gray7};
        `,
    },
    dotsSelected: {
        css: css`
            width: 50px;
            height: 4px;
            border-radius: 2px 2px 2px 2px;
            z-index:9;
            background-color:${ADIColors.darkBlue1};
        `,
    },
    modalInputGrid: {
        width: 12,
        css: css`
          padding: 0 15px;
          .modalSave {
            margin: 1.5rem 0 1.5rem 0;
          }
          .modalCancel {
            margin: 1.5rem 0 0.65rem  1.5rem;
          }
        `,
    },
    radioGridItem: {
        css: css`
          display: flex;
          flex-direction: column;
        `,
    },
    radioListGroup: {
        css: css`
            & > div {
              margin-right:10px !important;
              label {
                font-weight: bold;
              }
            }
        `,
    },
    VNCloseIcon: {
        css: css`
          position: absolute;
          right: 10px;
          width: 20px;
          height: 21px;
          top: 10px;
          z-index: 0;
          cursor: pointer;
        `,
    },
    VNEditIcon: {
        css: css`
          position: absolute;
          right: 10px;
          width: 20px;
          height: 21px;
          bottom: 10px;
          cursor: pointer;
        `,
    },
    nonEditableTopContainer:{
        css: css`
         width: 100%;
          margin-bottom: 50px;
          justify-content:center;
        `,
    }
};

const styles = visualFilterStyles;

export const ADIProductListVisualFilters: FC<Props> = ({
    isLoading,
    visualFilterState,
    category,
    session,
    location,
    catalogPath,
    loadVisualFilters,
    createVisualNavigation,
    addProductFilters,
    clearAllProductFilters,
    fields,
}) => {
    console.log("fields[imageNameFields.imageName]",fields[imageNameFields.imageName])
    const [emblaRef, embla] = useEmblaCarousel();
    const [isMobile, setIsMobile] = useState(false);
    const [isTablet, setIsTablet] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [numDots, setNumDots] = useState(0);
    const [modalOpen, setModalOpen] = useState(false);
    const [errorModalOpen, setErrorModalOpen] = useState(false);
    const [isEditView, setIsEditView] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isUserAdmin, setUserAdmin] = useState(false);
    const [dataForGridItems, setDataForGridItems] = useState<VisualFilter[]>([]);
    const [fromDate, setFromDate] = useState<Date | undefined>(undefined);
    const [toDate, setToDate] = useState<Date | undefined>(undefined);
    const defaultFromDate = fromDate || new Date();
    const [itemsDisabled, setItemsDisabled] = useState<Number[]>([]);
    const [dataForGridItemIndex, setDataForGridItemIndex] = useState("");
    const toasterContext = useContext(ToasterContext);
     const [showVisNav, setShowVisNav] = useState(false);

    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate());
    const [selectedDate, setSelectedDate] = useState(tomorrow);
    const currentPageUrl = location.pathname;
    const slidePerView = 3;

    const isCategoryPLP = location.pathname.toLowerCase().startsWith("/catalog/");
    const isBrandPLP = location.pathname.toLowerCase().startsWith("/catalog/shop-brands");

    const tzOffset = new Date().getTimezoneOffset() * 60000;


    useEffect(() => {
    if (typeof window !== 'undefined' && catalogPath) {
        if ((visualFilterState?.pageURL)?.toLocaleLowerCase() !== catalogPath.toLocaleLowerCase())
            setShowVisNav(false);
        else if ((visualFilterState?.pageURL)?.toLocaleLowerCase() === catalogPath.toLocaleLowerCase())
            setShowVisNav(true);

    }
}, [typeof window !== 'undefined' ? window.location.pathname : null, visualFilterState]);
   

    useEffect(() => {
        if (session.isAuthenticated
            && session.userRoles?.includes("Administrator")
        ) {
            setUserAdmin(true)
            setIsAuthenticated(true)
        }
    }, [session])

    React.useEffect(() => {
        if (catalogPath || isBrandPLP) {
            loadVisualFilters({
                pathUrl : isBrandPLP ? (location.pathname || "") : (catalogPath || ""),
            });
        }
    }, [catalogPath, location.pathname]);

    React.useEffect(() => {
        if (!embla) {
            return;
        }
        if (visualFilterState?.visualFilters.length) {
            setNumDots(Math.ceil(visualFilterState?.visualFilters.length / slidePerView));
        }
        embla.on("select", () => {
            setSelectedIndex(embla.selectedScrollSnap());
        });

        embla.reInit({
            align: "start",
            slidesToScroll: slidePerView,
            draggable: true,
            loop: false,
            containScroll: "trimSnaps",
        });
    }, [embla, visualFilterState]);

    React.useEffect(() => {
        const onWindowResize = () => {
            if (window.innerWidth >= 700) {
                setIsMobile(false);
            } else {
                setIsMobile(true);
            }
            if (window.innerWidth >= 991) {
                setIsTablet(false);
            } else {
                setIsTablet(true);
            }
             
        };

        if (typeof window !== "undefined") {
            window.addEventListener("resize", onWindowResize);
            onWindowResize();
        }

        return () => {
            window.removeEventListener("resize", onWindowResize);
        };
    }, []);

    useEffect(() => {
        if (visualFilterState?.visualFilters && !dataForGridItems.length) {
            setDataForGridItems(visualFilterState.visualFilters);
        }
    }, [visualFilterState?.visualFilters]);

    const filterCat: categoryId = {
        categoryId: "",
        shortDescription: ""
    };

    const defaultItem = {
        filterTitle: 'Filter Title',
        productImage: '/UserFiles/US/UserFiles/noImag.svg',
        visualFilterID: "",
        productNumber: "",
        pageURL: "/",
        attributeFilters: "", // Initialize with an empty string instead of undefined
        categoryID: filterCat,
        sort: "",
        pageSize: undefined,
        boostIDs: undefined,
        searchWithin: undefined,
        expand: "",
        isDisabled: false,
        isToBeAdded: false,
        class: undefined,
        dataGaPromo: "",
        visualNavType: 1,
        coveoAttributeFilters: "",
        slideNumber:1,
        adiLink:""
    };

    const dotButtons = Array.from({ length: numDots }, (_, index) => (
        <StyledWrapper
            key={index}
            {...(selectedIndex === index ? styles.dotsSelected : styles.dots)}
            onClick={() => embla?.scrollTo(index * slidePerView)}
        ></StyledWrapper>
    ));

    const gridList = useMemo(() => {
        if (dataForGridItems.length)
            return dataForGridItems.map((item, index) => {
                const sortDisble = itemsDisabled.sort((a: any, b: any) => a - b)
                return <GridItem width={2} {...styles.boxItem} key={`${item?.filterTitle}_${index}`}>
                    <StyledWrapper {...styles.boxContainer} className={`visual-navigation-item ${sortDisble.includes(index) && sortDisble[0] !== index && "disabled"}`}>
                        <StyledWrapper {...styles.VNCloseIcon} onClick={() => removeItem(index)}>
                            <Img src={'/UserFiles/US/UserFiles/removeIcon.svg'} />
                        </StyledWrapper>
                        <Img {...styles.images} src={item.productImage} />
                        <Typography as={"h3"} {...styles.title}>
                            {item.filterTitle}
                        </Typography>
                        <StyledWrapper {...styles.VNEditIcon} onClick={() => openModalFunction(index)}>
                            <Img src={'/UserFiles/US/UserFiles/editIcon.svg'} />
                        </StyledWrapper>
                    </StyledWrapper>
                </GridItem>
            })
        else
            return <></>
    }, [dataForGridItems, itemsDisabled])

    const openModalFunction = (attr: any) => {
        setModalOpen(true);
        setDataForGridItemIndex(attr);
    }

    const closeModal = () => setModalOpen(false);
    const closeErrorModal = () => setErrorModalOpen(false);

    const saveFilter = () => {
        closeModal();
    };


    const setProductAttribute = (id: string) => {
        clearAllProductFilters();
        if (id) {
            addProductFilters({
                attributes: [id],
            });
        }
    };

    const removeItem = useCallback((index: number) => {
        // console.log("Temp ==== data ",dataForGridItems);
        // let temp : any = [];
        // for (let item = 0 ; item  < dataForGridItems.length ; item++){
        //     console.log("Temp ==== ",item, index);
        //     if(index != item){
        //         console.log("Temp ==== iner");
        //         temp.push(dataForGridItems)
        //     }
        // }
        // console.log("Temp ==== ",temp, index);

        // setDataForGridItems(temp);

        setDataForGridItems(prevData => {
            const newData = [...prevData];
            newData[index] = { ...defaultItem, attributeFilters: newData?.[index]?.attributeFilters }
            return newData;

        });
        setItemsDisabled((prvState) => {
            return [...prvState, index];
        })
    }, []);

    const editVNContainer = () => {
        if (!visualFilterState?.visualFilters || visualFilterState.visualFilters.length === 0) {
            const initialData = Array.from({ length: 12 }, () => ({ ...defaultItem }));
            setDataForGridItems(initialData);
            setItemsDisabled(Array.from({ length: initialData.length }, (_, i) => i));
        } else {
            let initialData = [];
            let disableData = [];
            for (let item of visualFilterState.visualFilters) {
                initialData.push(item)
            }

            for(let index = initialData.length; index < 12 ; index++){
                disableData.push(index);  
            }
            for (let i = initialData.length; i < 12; i++) {
                initialData.push({ ...defaultItem })
            }
            setItemsDisabled(disableData);
            setDataForGridItems(initialData);

        }
        setIsEditView(true);
    }

    const saveNavigation = () => {
        if (itemsDisabled.length > 8) {
            setErrorModalOpen(true);
        }
        else {
            let finalDataForGridItems: any = [];
            for (let i = 0; i < dataForGridItems.length; i++) {
                if (dataForGridItems[i].productNumber !== "") {
                    finalDataForGridItems.push(dataForGridItems[i])
                }
            }
        
            createVisualNavigation({
                isAdminView: isUserAdmin,
                uri: null,
                visualFilterCollectionID: visualFilterState?.visualFilterCollectionID?.toString() || "",
                categoryName: null,
                subCategoryName: null,
                visualFilters: finalDataForGridItems,
                pageURL: currentPageUrl,
                validFrom: fromDate ? convertDateToString(fromDate) : convertDateToString(defaultFromDate),
                validTo: convertDateToString(toDate),   // "10/21/2023"
                properties: {},
                onSuccess: () => {
                    loadVisualFilters({
                        pathUrl: catalogPath || "",
                    });
                    setIsEditView(false)
                },
                onError: () => {
                    toasterContext.addToast({
                        body: "An error occurred while creating visual navigation.",
                        messageType: "danger",
                    });
                },
            })
        }
    }

    const convertDateToString = (date?: Date) => {
        if (!date) return "";
        const newDate = new Date(date.getTime() - tzOffset);
        const convertedDate = `${newDate.getMonth() + 1}/${newDate.getDate()}/${newDate.getFullYear()}`;
        return convertedDate;
    };

    const fromDateChangeHandler = ({ selectedDay }: Pick<DatePickerState, "selectedDay">) => {
        setFromDate(selectedDay);
    };

    const toDateChangeHandler = ({ selectedDay }: Pick<DatePickerState, "selectedDay">) => {
        setToDate(selectedDay);
    };

    const resetCalender = () => {
        setToDate(undefined); // Reset toDate to null
    };


    if (!isCategoryPLP || isLoading) {
        return null;
    }

    const setDataForGridItemsHandler = (data: VisualFilter[]) => {
        setDataForGridItems(data);
    };


    const setItemsDisabledHandler = (index: Number) => {
        setItemsDisabled(itemsDisabled.filter((e: any) => e != index));
    };

    const enum fieldsEnum {
        showArrows = "showArrows",
        slideIndicator = "slideIndicator",
        autoplay = "autoplay",
    }
    const fieldsForCarousal = {
        [fieldsEnum.showArrows]: true,
        [fieldsEnum.slideIndicator]: false,
        [fieldsEnum.autoplay]: false,
    };

    if (!visualFilterState?.visualFilters) return null;

    return (isMobile && !isLoading) ? (
        <StyledWrapper>
            <StyledWrapper {...styles.carouselContainer} ref={emblaRef}>
                <StyledWrapper {...styles.carouselSlidesContainer}>
                    {visualFilterState?.visualFilters.map((item: any) => (
                        <StyledWrapper {...styles.carouselSlide} key={item.attributeFilters}>
                            <StyledWrapper {...styles.carouselSlideInner}>
                                <StyledWrapper {...styles.boxContainerForMobile}>
                                    <Clickable onClick={() => setProductAttribute(item.attributeFilters)}>
                                        <Img {...styles.images} src={item.productImage} />
                                        <Typography as={"h3"} {...styles.title}>
                                            {item.filterTitle}
                                        </Typography>
                                    </Clickable>
                                </StyledWrapper>
                            </StyledWrapper>
                        </StyledWrapper>
                    ))}
                </StyledWrapper>
            </StyledWrapper>
            <StyledWrapper {...styles.dotsContainer}>{dotButtons}</StyledWrapper>
        </StyledWrapper>
    ) : (
        (isTablet && !isLoading) ? (
            <StyledWrapper {...styles.nonEditableTopContainer}>
                <StyledWrapper {...styles.carouselContainer} ref={emblaRef}>
                    <StyledWrapper {...styles.carouselSlidesContainer}>
                        {visualFilterState?.visualFilters.map((item: any) => (
                            <StyledWrapper {...styles.carouselSlide} style={{flex: "0 0 calc(100% / 6)"}} key={item.attributeFilters}>
                                <StyledWrapper {...styles.carouselSlideInner}>
                                    <StyledWrapper {...styles.boxContainerForMobile}>
                                        <Clickable onClick={() => setProductAttribute(item.attributeFilters)}>
                                            <Img {...styles.images} src={item.productImage} />
                                            <Typography as={"h3"} {...styles.title}>
                                                {item.filterTitle}
                                            </Typography>
                                        </Clickable>
                                    </StyledWrapper>
                                </StyledWrapper>
                            </StyledWrapper>
                        ))}
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
        ):

        <>
            {isAuthenticated && (
                <>
                    {isEditView ? (
                        <>
                            <Button onClick={saveNavigation} variant="primary" {...styles.saveNavigationBtn}>Save Visual Navigation</Button>
                            <StyledWrapper {...styles.parentWrap}>
                                {/* Calender */}
                                <StyledWrapper {...styles.dateMainWrap}>
                                    <StyledWrapper {...styles.dateWrapper}>
                                        <DatePicker
                                            label={"Start"}
                                            labelPosition={"left"}
                                            selectedDay={defaultFromDate}
                                            onDayChange={fromDateChangeHandler}
                                            format={"MM/dd/yyyy"}
                                            dateTimePickerProps={{
                                                clearIcon: null,
                                                maxDate: toDate,
                                                minDate: selectedDate ?? new Date(),
                                            }}
                                        />
                                        <DatePicker
                                            label={"End"}
                                            labelPosition={"left"}
                                            selectedDay={toDate}
                                            onDayChange={toDateChangeHandler}
                                            format={"MM/dd/yyyy"}
                                            dateTimePickerProps={{
                                                clearIcon: null,
                                                minDate: fromDate ?? new Date(), // Set minDate based on fromDate

                                            }}
                                        />
                                        {!toDate ? (
                                            <Typography {...styles.neverExpired}>{translate("Never Expires")}</Typography>
                                        ) : null}

                                        <Link
                                            {...styles.resetCalenderBtn}
                                            type="button"
                                            onClick={resetCalender}>
                                            {'Reset'}
                                        </Link>
                                    </StyledWrapper>
                                </StyledWrapper>
                                {/* Edit Section */}
                                <StyledWrapper {...styles.editWrapper}>
                                    <StyledWrapper className="visualNavigationContainer">
                                    
                                        <GridContainer {...styles.mainContainer}>
                                            <>{gridList}</>
                                        </GridContainer>
                                    
                                    </StyledWrapper>
                                    <StyledWrapper className="vn-footer-text">Please include 4-12 filter navigation slides.</StyledWrapper>
                                </StyledWrapper>
                                {/* Edit Section End */}
                            </StyledWrapper>
                        </>
                    ) : (
                        <>
                            <Link
                                {...styles.editNavigationLink}
                                type="button"
                                onClick={editVNContainer}>
                                {/* {"Edit Visual Navigation"} */}
                                {
                                    (visualFilterState?.visualFilters?.length ?? 0) > 0
                                        ? "Edit Visual Navigation"
                                        : "Add Visual Navigation"
                                }
                            </Link>
                        </>
                    )}
                </>
            )}

            {/* View Only */}
            {!isEditView && !isLoading && showVisNav && (
                <StyledWrapper  {...styles.nonEditableTopContainer}>
                <EmblaCarouselWrappeForVisNav fields = {fieldsForCarousal} styles={visualFilterStyles} 
                carouselList={visualFilterState?.visualFilters}
                isMobile = {isMobile} 
                isTablet = {isTablet}
                >
                <StyledWrapper {...styles.mainContainerViewOnly}>
                        {visualFilterState?.visualFilters.map((item: any) => (
                            <StyledWrapper {...styles.carouselSlide} style={{flex: "0 0 calc(100% / 6)"}} key={item.attributeFilters}>
                            <StyledWrapper {...styles.carouselSlideInner}>
                                <StyledWrapper {...styles.boxContainerForMobile} onClick={() => setProductAttribute(item.attributeFilters)}>
                                    <Img {...styles.images} src={item.productImage} />
                                    <Typography as={"h3"} {...styles.title}>
                                    {item.filterTitle}
                                    </Typography>
                                </StyledWrapper>
                            </StyledWrapper>
                            </StyledWrapper>
                        ))}
                    </StyledWrapper>
                 </EmblaCarouselWrappeForVisNav>
                 </StyledWrapper>
            )}
            {/* Modal for editing filter */}
            <ADIProductListVisualFilterModal
                closeModal={closeModal}
                modalOpen={modalOpen}
                dataForGridItemIndex={dataForGridItemIndex}
                setDataForGridItemIndex={setDataForGridItemIndex}
                dataForGridItems={dataForGridItems}
                defaultItem={defaultItem}
                category={category}
                setDataForGridItemsHandler={setDataForGridItemsHandler}
                setItemsDisabledHandler={setItemsDisabledHandler}
                imageAcceptedName = {fields[imageNameFields.imageName]}
            />
            {/* Modal for Save Nav Error */}
            <Modal
                headline={"Error"}
                isOpen={errorModalOpen}
                handleClose={closeErrorModal}
                sizeVariant={"small"}
                {...styles.errorModal}
            >
                <StyledWrapper>
                    <StyledWrapper {...styles.errorModalWrap}>
                        <Typography>{'Please provide visual navigation for all 4 blocks or else none will be displayed on this page.'}</Typography>
                    </StyledWrapper>
                    <Button onClick={closeErrorModal} variant="primary" className="modalSave" {...styles.errorModalClose}>CLOSE</Button>
                </StyledWrapper>
            </Modal>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ADIProductListVisualFilters),
    definition: {
        group: "Basic",
        icon: "Image",
        displayName: "Product List Visual Filters",
        fieldDefinitions: [ {
            name: imageNameFields.imageName,
            editorTemplate: "TextField",
            displayName: "Image Name",
            defaultValue: "Sale.jpg,Clearance.jpg,InStock.jpg,Accessories.jpg,New.jpg,Deals.jpg,NDAA.jpg",
            fieldType: "General",
            isRequired: true,
            sortOrder: 1,
        },],
    },
};

export default widgetModule;

